export default __webpack_public_path__ + "static/media/plain-sticker-5.b39a4beb.png";